import { render, staticRenderFns } from "./back-confirm-modal.vue?vue&type=template&id=2861e92a"
import script from "./back-confirm-modal.vue?vue&type=script&lang=js"
export * from "./back-confirm-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports